/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvancedShippingNotesV3 } from '../../models/advanced-shipping-notes-v-3';
import { KeyType } from '../../models/key-type';

export interface PostAdvancedShippingNotesV3$Params {
  organizationSiteKey: KeyType;
      body: AdvancedShippingNotesV3
}

export function postAdvancedShippingNotesV3(http: HttpClient, rootUrl: string, params: PostAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdvancedShippingNotesV3.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdvancedShippingNotesV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes';
